webpackJsonp([273043685054050],{

/***/ 641:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Letop = __webpack_require__(7);
	
	var _Letop2 = _interopRequireDefault(_Letop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col bor-bot" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "mannelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "vrouwelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "onzijdig"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "hic"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "haec"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "hoc"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "huius"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "huius"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "huius"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "huic"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "huic"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "huic"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "hunc"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "hanc"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "hoc"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col bor-bot" },
	            "abl. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "hoc"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "hac"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "hoc"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "hi"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "hae"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "haec"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "horum"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "harum"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "horum"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "his"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "his"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "his"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "hos"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "has"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "haec"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col bor-bot" },
	            "abl. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "his"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "his"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "his"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            { colSpan: 3, className: "center" },
	            _react2.default.createElement(
	              "i",
	              null,
	              "1. deze, dit \xA0\xA0\xA0 2. hij, zij, het"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col bor-bot" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "mannelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "vrouwelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "onzijdig"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ille"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "illa"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "illud"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "illius"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "illius"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "illius"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "illi"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "illi"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "illi"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "illum"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "illam"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "illud"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col bor-bot" },
	            "abl. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "illo"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "illa"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "illo"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "illi"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "illae"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "illa"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "illorum"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "illarum"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "illorum"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "illis"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "illis"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "illis"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "illos"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "illas"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "illa"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col bor-bot" },
	            "abl. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "illis"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "illis"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "illis"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            { colSpan: 3, className: "center" },
	            _react2.default.createElement(
	              "i",
	              null,
	              "1. die, dat \xA0\xA0\xA0 2. hij, zij, het"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col bor-bot" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "mannelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "vrouwelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "onzijdig"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "iste"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ista"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "istud"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "istius"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "istius"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "istius"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "isti"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "isti"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "isti"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "istum"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "istam"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "istud"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col bor-bot" },
	            "abl. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "isto"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "ista"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "isto"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "isti"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "istae"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ista"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "istorum"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "istarum"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "istorum"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "istis"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "istis"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "istis"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "istos"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "istas"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ista"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col bor-bot" },
	            "abl. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "istis"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "istis"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "istis"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            { colSpan: 3, className: "center" },
	            _react2.default.createElement(
	              "i",
	              null,
	              "1. die, dat \xA0\xA0\xA0 2. hij, zij, het"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement(
	        _Letop2.default,
	        null,
	        "Deze rijtjes lijken erg op het rijtje van",
	        " ",
	        _react2.default.createElement(
	          "a",
	          { href: "bijvoeglijk-naamwoord" },
	          _react2.default.createElement(
	            "b",
	            null,
	            "longus"
	          )
	        ),
	        ". Alleen de nominativus, genitivus en dativus enkelvoud wijken af."
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 695:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TableSelector = __webpack_require__(28);
	
	var _TableSelector2 = _interopRequireDefault(_TableSelector);
	
	var _aanwVnw = __webpack_require__(641);
	
	var _aanwVnw2 = _interopRequireDefault(_aanwVnw);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var data = [{
	  les: "40",
	  table: _aanwVnw2.default
	}];
	
	exports.default = function () {
	  return _react2.default.createElement(_TableSelector2.default, {
	    defaultChapter: "40",
	    data: data,
	    title: "Aanwijzend voornaamwoord"
	  });
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-spqr-rijtjes-aanwijzend-voornaamwoord-js-9795aa8ef02a91121be2.js